module.exports = __webpack_public_path__ + "img/millsite.fe8f7a1f.png";